import script from "./NoResultsInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./NoResultsInfo.vue?vue&type=script&setup=true&lang=ts"

import "./NoResultsInfo.vue?vue&type=style&index=0&id=6ee77418&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ee77418"]])

export default __exports__